<template>
  <b-modal @ok="onOkClick" @show="onModalShow" id="editLVPreisModal" title="LV Preis eingeben">
    <b-form ref="lvPreisForm" id="lvPreisForm" @submit.stop.prevent="handleSubmit">
      <!--
      <b-form-group id="input-group-ordinal" label="LV-Preis" label-for="input-lvpreis">
        <b-form-input
          v-model="value.LVPreis"
          min="0"
          step="0.01"
          id="input-lvpreis"
          type="number"
          placeholder="LV-Preis"
          required
          autofocus
          @focus="$event.target.select()"
          @keyup.enter="onOkClick()"
        ></b-form-input>
      </b-form-group>
      -->

      <AkCurrencyField
        v-model="value.LVPreis"
        input-class="text-right"
        min="0"
        id="input-lvpreis"
        placeholder="LV-Preis"
        autofocus
        @focus="$event.target.select()"
        @keyup.enter="onOkClick()"
      />
    </b-form>
  </b-modal>
</template>

<script>
import AkCurrencyField from '@/components/AkCurrencyField';
export default {
  components: {
    AkCurrencyField
  },
  props: ['allocationUnit'],
  data() {
    return {
      value: {
        LVPreis: null
      }
    };
  },
  emits: ['ok', 'error'],
  methods: {
    handleSubmit() {
      if (!this.$refs.lvPreisForm.checkValidity()) {
        return this.$refs.lvPreisForm.reportValidity();
      }
      this.allocationUnit.LVPreis = this.value.LVPreis;
      this.$emit('ok', this.allocationUnit);
      this.$nextTick(() => {
        this.$bvModal.hide('editLVPreisModal');
      });
    },
    onOkClick(bvModalEvent) {
      if (bvModalEvent) bvModalEvent.preventDefault();
      this.handleSubmit();
    },
    onModalShow() {
      this.value = { ...this.allocationUnit };
    }
  }
};
</script>

<style></style>
